import React, { Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { API_CloudBeds_Connection, API_CloudBeds } from '../../../../constants/APIs';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
class Index extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        var restUrl = window.location.href.substring(window.location.href.lastIndexOf("?") + 6,
            window.location.href.lastIndexOf("&"));
        var state = window.location.href.substring(window.location.href.lastIndexOf("&") + 7,
            window.location.href.length);
        console.log(restUrl, state);
        if (this.props.cloudBedsId !== undefined) {
            AxiosAPI({
                method: 'post',
                url: `${API_CloudBeds_Connection}/code/${this.props.cloudBedsId}?group_id=${getGroupID()}`,
                data: ({
                    code: restUrl,
                    type: 'bmb'
                })
            }).then((m) => {
                console.log(m);
                localStorage.setItem("ShowCloudbedsMessage", true);
                window.location.href = `/app/pages/integration/applications`;
                // AxiosAPI({
                //     method: 'Get',
                //     url: `${API_CloudBeds}/${this.props.cloudBedsId}?group_id=${getGroupID()}`,                    
                // }).then((res) => {
                //     console.log(res.data);
                //     AxiosAPI({
                //         method: 'put',
                //         url: `${API_CloudBeds}/${this.props.cloudBedsId}?group_id=${getGroupID()}`,
                //         data: data
                //     }).then((json) => {
                //         console.log(json.data);
                //       //  localStorage.setItem("ShowMessage", true);
                //        // window.location.href = `/app/pages/integration`;
                //     });

                // });
            });
        } else {
            if (this.props.propertyId !== undefined) {
                const inputData = {
                    GroupId: getGroupID(),
                    Name: '',
                    Properties: [this.props.propertyId],
                    SessionTimeoutInSeconds: 600,
                    DefaultLanguage: 'en-US',
                    clientId: process.env.REACT_APP_CLOUDBEDS_CLIENT_ID,
                    clientSecretKey: process.env.REACT_APP_CLOUDBEDS_CLIENT_SECRET_KEY,
                    domainName: '',
                    redirectUrl: '',
                    AccessToken: '',
                    RefreshToken: ''
                };
                AxiosAPI({
                    method: 'post',
                    url: API_CloudBeds,
                    data: inputData,
                }).then((res) => {
                    AxiosAPI({
                        method: 'post',
                        url: `${API_CloudBeds_Connection}/code/${res.data.id}?group_id=${getGroupID()}`,
                        data: ({
                            code: restUrl,
                        })
                    }).then((m) => {
                        localStorage.setItem("ShowCloudbedsMessage", true);
                        window.location.href = `/app/pages/integration/applications`;
                    });
                });
            }
        }
    }

    render() {
        return (
            <Fragment></Fragment>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, cloudBedsId } = settings;
    return {
        propertyId, cloudBedsId
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));